/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef } from "react";
import SourceCard from "../components/sections/SourceCard";
import UseCaseCard from "../components/sections/UseCaseCard";
import Image from "../components/elements/Image";
import { Link, useHistory } from "react-router-dom";
import ScrollReveal from "../utils/ScrollReveal";
import HelmetWrapper from "../components/sections/HelmetWrapper";
import { analystMetaData } from "../seo/metaDeta";

// can edit use cases from this array.
let useCases = [
  {
    tag: "centralize",
    heading: "Create a data stack in 40 mins",
    subHeading:
      "Quickly spin up a modern data stack that allows you to ingest data from 140+ connectors into a managed data warehouse provided by us without engineering work.",
    img: require("../assets/images/data-analyst-feature-1.svg"),
  },
  {
    tag: "value",
    heading: "Analyze data, not the infrastructure",
    subHeading:
      "When it comes to your data infrastructure, set it and forget it. Datazip makes it that easy for you to devote more time on analysis as you don't have to update APIs, maintain integrations, or work with multiple vendors.",
    img: require("../assets/images/data-analyst-feature-2.svg"),
  },
  {
    tag: "self-serve",
    heading: "Set the stage for a data-driven culture",
    subHeading:
      "Data democratization benefits everyone. With no-code and SQL-only solutions, you can enable anyone to access, comprehend, and use data. Manage your business login centrally and in a collaborative manner to spend less time dealing with routine inquiries and straightforward requests.",
    img: require("../assets/images/data-analyst-feature-3.svg"),
  },
];

let Connectors = [
  {
    name: "Google Analytics",
    img: require("../assets/images/connectors/google_analytics.png"),
    isAlpha: false,
    link: "",
    category: "",
  },
  {
    name: "Google Ads",
    img: require("../assets/images/connectors/google_ads.png"),
    isAlpha: false,
  },
  {
    name: "Quickbooks",
    img: require("../assets/images/connectors/quickbooks.png"),
    isAlpha: false,
  },
  {
    name: "Airtable",
    img: require("../assets/images/connectors/airtable.png"),
    isAlpha: false,
  },
];
const DataAnalyst = () => {
  const childRef = useRef();
  const history = useHistory();
  useEffect(() => {
    childRef.current.init();
  }, []);
  return (
    <>
      <HelmetWrapper {...analystMetaData} />
      <ScrollReveal
        ref={childRef}
        children={() => (
          <div className="container use">
            <div className="use__container">
              <div className="use__text-container">
                <div className="use__text-tag reveal-from-left">
                  Data Analyst Use Cases
                </div>
                <div className="use__text-heading reveal-from-left">
                  Let us engineer data for you
                </div>
                <div className="use__text-sub reveal-from-bottom">
                  Get scalable data infrastructure without the engineering
                  efforts
                </div>
              </div>
              <img
                className="use__background reveal-from-right"
                src={require("../assets/images/data-analyst-main.svg")}
                alt="case"
              />
            </div>
            {/* <div className="divider" /> */}
            {/* <div
        className="use__testimonial-box reveal-from-bottom"
        data-reveal-delay="200"
      >
        <img src={require("../assets/images/docker.svg")} alt="company_logo" />
        <div className="use__testimonial-text">
          "Most marketing people don't know how to build a data stack. Because
          of the CSM and the analyst support we’re getting from Mozart Data, it
          gives me more confidence in what we’re doing. It’s great to have a
          professional available to help answer the deeper questions."
        </div>
        <div className="use__testimonial-author">
          <img
            src={require("../assets/images/author.png")}
            alt="author"
            className="author-img"
          />
          <div className="author-name">
            Kristin Watson{" "}
            <span className="author-position">/ CEO, Docker</span>
          </div>
        </div>
      </div> */}
            <div className="divider" />
            <div className="use__cases-box">
              {useCases.map((item, index) => {
                return <UseCaseCard data={item} key={index} index={index} />;
              })}
            </div>
            <div className="datazip__case">
              <div className="heading"> Use Cases</div>
              {/* <div className="subHeading">
          Please let us know, we will get back to you about how quickly we can
          make it available
        </div> */}
              <div className="box">
                <div className="tiles-item reveal-from-bottom">
                  {/* start  */}
                  <div className="tiles-item-inner">
                    <div className="features-tiles-item-header ta-c">
                      <div className="features-tiles-item-image mb-16 ">
                        <Image
                          src={require("./../assets/images/data-analyst-feature-tile-icon-01.svg")}
                          alt="Features tile icon 01"
                          width={64}
                          height={64}
                        />
                      </div>
                    </div>
                    <div className="features-tiles-item-content ta-c">
                      {/* <h4 className="mt-0 mb-8">No-Code</h4> */}
                      <p className="m-0 text-sm">
                        Setup a single source of truth for everyone
                      </p>
                    </div>
                    <button className="button__main">
                      Read More{" "}
                      <img
                        src={require("./../assets/images/long-arrow-right.svg")}
                        alt="arrow right"
                      />
                    </button>
                  </div>
                </div>
                {/* end */}
                {/* start  */}
                <div className="tiles-item reveal-from-bottom">
                  <div className="tiles-item-inner">
                    <div className="features-tiles-item-header ta-c">
                      <div className="features-tiles-item-image mb-16 ">
                        <Image
                          src={require("./../assets/images/data-analyst-feature-tile-icon-02.svg")}
                          alt="Features tile icon 02"
                          width={64}
                          height={64}
                        />
                      </div>
                    </div>
                    <div className="features-tiles-item-content ta-c">
                      {/* <h4 className="mt-0 mb-8">No-Code</h4> */}
                      <p className="m-0 text-sm">Set up automated reporting</p>
                    </div>
                    <button className="button__main">
                      Read More{" "}
                      <img
                        src={require("./../assets/images/long-arrow-right.svg")}
                        alt="arrow right"
                      />
                    </button>
                  </div>
                </div>
                <div className="tiles-item reveal-from-bottom">
                  {/* end */}
                  {/* start  */}
                  <div className="tiles-item-inner">
                    <div className="features-tiles-item-header ta-c">
                      <div className="features-tiles-item-image mb-16 ">
                        <Image
                          src={require("./../assets/images/data-analyst-feature-tile-icon-03.svg")}
                          alt="Features tile icon 03"
                          width={64}
                          height={64}
                        />
                      </div>
                    </div>
                    <div className="features-tiles-item-content ta-c">
                      {/* <h4 className="mt-0 mb-8">No-Code</h4> */}
                      <p className="m-0 text-sm">
                        Prepare data for analysis and machine learning
                      </p>
                    </div>
                    <button className="button__main">
                      Read More{" "}
                      <img
                        src={require("./../assets/images/long-arrow-right.svg")}
                        alt="arrow right"
                      />
                    </button>
                  </div>
                  {/* end */}
                </div>
              </div>
            </div>
            <div className="integration__box">
              <div className="integration__box-heading">
                Connect your data in minutes
              </div>
              <div className="integration__box-connector">
                {Connectors.map((item, index) => {
                  return <SourceCard source={item} key={index} />;
                })}
              </div>
              <Link to={"/onestack-data/connectors"}>
                <button className="integration__box-button">
                  See all integrations
                </button>
              </Link>
            </div>
            <div className="divider" />
            <div className="use__freeTrial">
              <div className="freeTrial__textbox">
                <div className="freeTrial__textbox-1">
                  All teams can benefit from centralized and reliable data
                </div>
                <div className="freeTrial__textbox-2">
                  Start your free trial today
                </div>
                <div className="freeTrial__elipse"></div>
              </div>
              <div className="freeTrial__cta">
                <a href="">
                  <button
                    className="freeTrial__cta-common freeTrial__cta-1"
                    onClick={() => {
                      history.push("/onestack-data/sign-up");
                    }}
                  >
                    Get Started
                  </button>
                </a>
                <Link to={"/onestack-data/login"}>
                  <button className="button__main button__tertiary">
                    Access Sandbox
                  </button>
                </Link>
              </div>
            </div>
          </div>
        )}
      />
    </>
  );
};

export default DataAnalyst;
